var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a44ad70ef8df152605b00ff0cfeeb9b3d2d9a344"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"a44ad70ef8df152605b00ff0cfeeb9b3d2d9a344"};
      